import { render, staticRenderFns } from "./Initiation.vue?vue&type=template&id=ca80f86c&scoped=true"
import script from "./Initiation.vue?vue&type=script&lang=js"
export * from "./Initiation.vue?vue&type=script&lang=js"
import style0 from "./Initiation.vue?vue&type=style&index=0&id=ca80f86c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca80f86c",
  null
  
)

export default component.exports